<template>
  <div id="app">
    <div v-if="getLoader" class="loader"></div>
    <Overlay />
    <MobileView id="mobile-v" class="md:hidden mobile-view"></MobileView>

    <DesktopView
      id="nav"
      class="hidden md:block desktop-view h-auto"
    ></DesktopView>

    <!-- Router View -->
    <!--  <router-view
      class="overflow-hidden w-8/12 md:left-0 2xl:left-0 md:inset-1080 2xl:inset-4K"
      :class="routerViewCSS"
      :style="!isMobile && isVideoView ? 'height: 85vh; top: 10vh;' : ''"
    /> -->
    <!--
 return this.isVideoView
          ? "h-full absolute left-0 top-0"
          : "mobile-content p-3";
      } else return "desktop-content mt-10";

 -->
    <router-view
      class="w-full md:mt-lg"
      :class="{
        'h-full absolute left-0 top-0': isMobile && isVideoView,
        'mobile-content p-3': isMobile && !isVideoView,
        'desktop-content': !isMobile,
        'absolute top-video-156 ml-lg': !isMobile && isVideoView,
      }"
    />

    <footer
      v-if="!isMobile"
      class="text-black text-center fixed bottom-0 right-0 w-2/12 flex justify-center"
    >
      <InformationComponent :isAbout="false" />
    </footer>
  </div>
</template>

<style>
#app {
  height: 100vh;
  width: 100vw;
}

html::-webkit-scrollbar {
  display: none;
  -ms-overflow-style: none;
}

/* 32vh with search bar and sort filter */
.mobile-view {
  height: auto;
  position: fixed;
  top: 0;
  z-index: 10;
  background: white;
}

.mobile-content {
  height: auto;
  position: absolute;
  top: 25vh;
}

.desktop-view {
  height: 30vh;
  width: 100vw;
  position: fixed;
  top: 0;
  z-index: 10;
  background: white;
}

.desktop-content {
  /* position: absolute; */
}

.edu-button:hover {
  background: #61d39c;
}

/* Loading spinner */
/* https://www.w3schools.com/howto/howto_css_loader.asp */
.loader {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -60px 0 0 -60px;
  z-index: 1000;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<script>
/* Components */
import DesktopView from "./views/DesktopView";
import MobileView from "./views/MobileView";
import Overlay from "./components/OverlayComponent";
import InformationComponent from "./components/base/InformationComponent";
import NavigationFilterComponent from "./components/NavigationFilterComponent";
import FiltersComponent from "./components/FiltersComponent";

import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../tailwind.config.js";

const fullConfig = resolveConfig(tailwindConfig);
const smallScreen = fullConfig.theme.screens.md.replace(/\D/g, "");

export default {
  components: {
    DesktopView,
    MobileView,
    Overlay,
    InformationComponent,
    NavigationFilterComponent,
    FiltersComponent,
  },
  data() {
    return {
      isMobile: false,
      isVideoView: false,
    };
  },
  mounted() {
    this.isMobile = smallScreen > window.screen.width;
    this.$store.commit("setIsMobile", this.isMobile);
    window.addEventListener("resize", this.responsiveWindow);
    this.$store.dispatch("fetchData");
  },
  methods: {
    responsiveWindow() {
      this.isMobile = smallScreen > window.screen.width;
      this.$store.commit("setIsMobile", this.isMobile);
    },
  },
  computed: {
    routerViewCSS() {
      if (this.isMobile) {
        return this.isVideoView
          ? "h-full absolute left-0 top-0"
          : "mobile-content p-3";
      } else return "desktop-content ";
    },
    getLoader() {
      return this.$store.getters.getLoader;
    },
  },
  watch: {
    $route(to) {
      this.isVideoView = to.name === "VideoView";
    },
  },
};
</script>
